/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { ContentfulModules } from '../helpers/modules'
import { Tabs as SparkTabs, TabPanel, TabPanels, TabList, TabButton } from '@uswitch/spark'
import { useEntities } from '../helpers/selectors'

const Tabs = ({ tabs = [] }) => {
  const { buttons, panels } = tabs.reduce(
    (result, { content, title }, index) => ({
      buttons: [
        ...result.buttons,
        <TabButton key={index} open={index === 0}>
          {title}
        </TabButton>,
      ],

      panels: [
        ...result.panels,
        <TabPanel key={index} open={index === 0}>
          <ContentfulModules modules={[content]} />
        </TabPanel>,
      ],
    }),
    { buttons: [], panels: [] },
  )

  return (
    <SparkTabs sx={{ py: 0 }}>
      <TabList>{buttons}</TabList>
      <TabPanels>{panels}</TabPanels>
    </SparkTabs>
  )
}

const TabsConnected = ({ entries, heading }) => {
  const tabs = useEntities(entries)

  return <Tabs tabs={tabs} heading={heading} />
}

export default TabsConnected
